"use client";
import EmblaSlider from "@/app/components/lib/Embla-slider";
import { TSlideWidith } from "@/app/components/lib/Embla-slider/EmblaSliderContainer";
import { JSX } from "react";

interface Props {
  widthArray: (number | string)[];
  spacing: number;
}
const BundleItemsSlider: React.FC<React.PropsWithChildren<Props>> = ({
  widthArray,
  children,
  spacing,
}) => {
  return (
    <EmblaSlider autoPlay={false} autoplayDuration={0}>
      <EmblaSlider.EmblaSliderViewport>
        <EmblaSlider.EmblaSliderContainer
          gap={spacing}
          slides={[
            ...(children as Array<JSX.Element>)?.map((child, idx) => ({
              component: (
                <div style={{ width: widthArray[idx], height: "100%" }}>
                  {child}
                </div>
              ),
              width: "auto" as TSlideWidith,
            })),
          ]}
        />
        <EmblaSlider.EmblaFilters />
        <EmblaSlider.EmblaSliderPrevNextButtons />
      </EmblaSlider.EmblaSliderViewport>
    </EmblaSlider>
  );
};

export default BundleItemsSlider;
